export default {
    consecutiveSignIn1: {icon: 'mdi-dots-triangle', color: 'light-blue', effect: [
        {name: 'currencyMiningScrapGain', type: 'mult', value: 1.3}
    ]},
    consecutiveSignIn2: {icon: 'mdi-account-group', color: 'green', effect: [
        {name: 'villageWorker', type: 'base', value: 8}
    ]},
    consecutiveSignIn3: {icon: 'mdi-sword', color: 'red', effect: [
        {name: 'hordeAttack', type: 'mult', value: 1.15}
    ]},
    consecutiveSignIn4: {icon: 'mdi-sprout', color: 'orange', effect: [
        {name: 'farmCropGain', type: 'mult', value: 1.15}
    ]},
    consecutiveSignIn5: {icon: 'mdi-palette', color: 'pink', effect: [
        {name: 'currencyGalleryBeautyGain', type: 'mult', value: 1.15}
    ]},
    consecutiveSignIn6: {icon: 'mdi-hammer-wrench', color: 'purple', effect: [
        {name: 'miningPickaxePremiumCraftingSlots', type: 'base', value: 1}
    ]},
    consecutiveSignIn7: {icon: 'mdi-temple-buddhist', color: 'deep-purple', effect: [
        {name: 'currencyVillageOfferingGain', type: 'mult', value: 1.2}
    ]},
    consecutiveSignIn8: {icon: 'mdi-crystal-ball', color: 'cyan', effect: [
        {name: 'currencyHordeMysticalShardCap', type: 'mult', value: 1.2}
    ]},
    consecutiveSignIn9: {icon: 'mdi-school', color: 'teal', effect: [
        {name: 'farmExperience', type: 'mult', value: 1.3}
    ]},
    consecutiveSignIn10: {icon: 'mdi-lightbulb', color: 'amber', effect: [
        {name: 'galleryInspirationStart', type: 'base', value: 5}
    ]},
    consecutiveSignIn11: {icon: 'mdi-diamond-stone', color: 'yellow', effect: [
        {name: 'gemGenSpeed', type: 'mult', value: 1.1}
    ]},
};
